const AUDIO_SOURCE = 'data:audio/mpeg;base64,/+MYxAAAAANIAUAAAASEEB/jwOFM/0MM/90b/+RhST//w4NFwOjf///PZu////9lns5GFDv//l9GlUIEEIAAAgIg8Ir/JGq3/+MYxDsLIj5QMYcoAP0dv9HIjUcH//yYSg+CIbkGP//8w0bLVjUP///3Z0x5QCAv/yLjwtGKTEFNRTMuOTeqqqqqqqqqqqqq/+MYxEkNmdJkUYc4AKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq';

const checkAutoplayWithSound = async() => {
	return new Promise((resolve) => {
		try {
			const audio = new Audio();
			audio.autoplay = true;
			audio.muted = false;
			audio.addEventListener('error', () => resolve(false));
			audio.src = AUDIO_SOURCE;
			audio.load();
			audio
				.play()
				.then(() => {
					audio.muted = true;
					audio.pause();
					resolve(true);
				})
				.catch(() => resolve(false));
		} catch {
			resolve(false);
		}
	});
};

export { checkAutoplayWithSound };
